import { render } from "./PurchaseCreationStep.vue?vue&type=template&id=216b16a6"
import script from "./PurchaseCreationStep.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseCreationStep.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Admin/Project/PurchaseCreationStep.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "216b16a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('216b16a6', __exports__)) {
    api.reload('216b16a6', __exports__)
  }
  
  module.hot.accept("./PurchaseCreationStep.vue?vue&type=template&id=216b16a6", () => {
    api.rerender('216b16a6', render)
  })

}


export default __exports__